const indexItems = [
  { label: '古装仙侠', icon: 'ri-sword-line', desc: '仙气飘飘，侠义长存', count: '326部', color: 'bg-primary-100 text-primary-700' },
  { label: '都市情感', icon: 'ri-heart-line', desc: '爱在霓虹之下', count: '518部', color: 'bg-accent-100 text-accent-700' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', desc: '层层剥茧，真相浮现', count: '289部', color: 'bg-secondary-200 text-secondary-700' },
  { label: '古装宫廷', icon: 'ri-building-line', desc: '深宫权谋，步步惊心', count: '156部', color: 'bg-primary-100 text-primary-700' },
  { label: '青春校园', icon: 'ri-book-open-line', desc: '最好的时光，最美的你', count: '203部', color: 'bg-accent-100 text-accent-700' },
  { label: '韩剧精选', icon: 'ri-kakao-talk-line', desc: '韩流经典，浪漫满分', count: '445部', color: 'bg-secondary-200 text-secondary-700' },
  { label: '美剧热榜', icon: 'ri-global-line', desc: '高分神作，口碑保证', count: '372部', color: 'bg-primary-100 text-primary-700' },
  { label: '日剧治愈', icon: 'ri-mental-health-line', desc: '温暖日常，治愈人心', count: '198部', color: 'bg-accent-100 text-accent-700' },
];

export default function Index() {
  return (
    <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm text-foreground-600">按类型快速找到你想看的电视剧</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.label}
              href="#topics"
              className="group bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer"
            >
              <span className={`w-10 h-10 flex items-center justify-center rounded-xl mb-3 ${item.color}`}>
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">{item.label}</h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-xs font-medium text-primary-600">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}